document.addEventListener('alpine:init', () => {
  const openCart = () => {
    if (window.__hgCartRecoveryPending) return;
    window.__hgCartRecoveryPending = true;
    const root = window.Shopify?.routes?.root || '/';
    window.location.assign(window.theme?.routes?.cart_url || `${root}cart`);
  };
  const announceError = (message) => {
    const node = document.getElementById('cart-errors');
    if (node) {
      node.setAttribute('role', 'alert');
      node.textContent = message;
    }
  };
  Alpine.data('CartItems', () => ({
    itemsRoot: null,
    loading: null,
    _onUpdate: null,
    init() {
      this.itemsRoot = this.$root;
      this._onUpdate = this.onCartQuantityChange.bind(this);
      window.addEventListener('baseline:cart:afteradditem', this._onUpdate);
      window.addEventListener('baseline:cart:cartqtychange', this._onUpdate);
    },
    destroy() {
      window.removeEventListener('baseline:cart:afteradditem', this._onUpdate);
      window.removeEventListener('baseline:cart:cartqtychange', this._onUpdate);
    },
    onCartQuantityChange(e) {
      if (!this.itemsRoot) return;
      try {
        const sections = e?.detail?.response?.sections;
        const html = sections?.['cart-items'];
        const nextItems = typeof html === 'string' && html.trim()
          ? querySelectorInHTMLString('[data-cart-items]', html)
          : null;
        if (!nextItems) { openCart(); return; }
        Alpine.morph(this.itemsRoot, nextItems.outerHTML);
        this.$nextTick(() => {
          this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
            inputEl.value = inputEl.getAttribute('value');
            inputEl.dispatchEvent(new Event('input'));
          });
        });
        const liveHTML = sections['cart-live-region'];
        if (typeof liveHTML === 'string' && liveHTML.trim()) {
          this.updateLiveRegion(parseDOMFromString(liveHTML).firstElementChild?.textContent);
        }
        if (e.detail.originalTarget) {
          this.$nextTick(() => {
            if (!this.itemsRoot.contains(e.detail.originalTarget) && this.$focus) {
              const dialog = this.itemsRoot.closest('[role="dialog"]');
              this.$focus.within(dialog ? dialog.parentNode : this.itemsRoot).first();
            }
          });
        }
      } catch (error) {
        console.error('Hunted+Gathered cart display could not refresh', error);
        openCart();
      }
    },
    updateLiveRegion(text) {
      const node = document.getElementById('cart-live-region-text');
      if (!node || !text) return;
      node.textContent = text;
      node.setAttribute('aria-hidden', 'false');
      setTimeout(() => node.setAttribute('aria-hidden', 'true'), 1000);
    },
  }));
  Alpine.data('CartItem', (key) => ({
    quantity: null,
    previousQuantity: null,
    key,
    locked: false,
    errorMessage: null,
    async itemQuantityChange() {
      if (this.locked || this.loading) return;
      const input = this.$refs.quantityInput;
      const quantity = Number(this.quantity);
      if (this.quantity === null || String(this.quantity).trim() === '' || !Number.isInteger(quantity) || quantity < 0) {
        this.errorMessage = 'Enter a whole-number quantity of zero or more.';
        announceError(this.errorMessage);
        return;
      }
      if (input.hasAttribute('data-last-value') && quantity === Number(input.dataset.lastValue)) return;
      const previous = input.hasAttribute('data-last-value')
        ? Number(input.dataset.lastValue)
        : this.previousQuantity;
      this.locked = true;
      this.loading = true;
      this.errorMessage = null;
      announceError('');
      try {
        const request = {
          ...fetchConfigDefaults('application/javascript'),
          body: JSON.stringify({
            id: this.key,
            quantity,
            sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
            sections_url: window.location.pathname,
          }),
        };
        const response = await fetch(theme.routes.cart_change_url, request);
        const data = await response.json();
        if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('Invalid cart response');
        if (!response.ok || data.status) {
          this.errorMessage = data.description || data.message || theme.strings.cartError;
          // Only restore a known previous quantity after an explicit inventory rejection.
          if ((response.status === 422 || data.status === 422) && previous !== null && Number.isFinite(Number(previous))) {
            this.quantity = Number(previous);
          }
          announceError(this.errorMessage);
          return;
        }
        const sections = data.sections || {};
        if (['cart-items', 'cart-footer', 'cart-item-count'].some((name) =>
          typeof sections[name] !== 'string' || !sections[name].trim())) {
          openCart();
          return;
        }
        document.body.dispatchEvent(new CustomEvent('baseline:cart:cartqtychange', {
          bubbles: true,
          detail: { response: data, originalTarget: this.$root },
        }));
      } catch (error) {
        // An unreadable response does not establish whether the change succeeded. Never replay the POST.
        this.errorMessage = 'We could not confirm the cart update. Open your cart to check before trying again.';
        announceError(this.errorMessage);
        console.error('Hunted+Gathered quantity update could not be confirmed', error);
      } finally {
        this.locked = false;
        this.loading = false;
      }
    },
    removeItem() {
      const control = Array.from(this.$root.querySelectorAll('[x-data="CartItemQuantity"]'))
        .find((el) => el.offsetParent);
      if (control) control.dispatchEvent(new CustomEvent('remove'));
    },
  }));
  Alpine.data('CartItemQuantity', () => ({
    init() { this.$root.addEventListener('remove', () => this.remove()); },
    remove() { this.adjustQuantity(() => { this.$refs.quantityInput.value = 0; }); },
    ...coreQuantity,
  }));
});
